<template>
  <v-btn
    block
    x-large
    outlined
    @click="$emit('click')"
    :append-icon="appendIcon"
    class="max-width-available"
    :color="disabled ? 'red' : 'accent'"
    :style="`border-color: ${disabled ? 'red' : 'var(--v-accent-base)'};`"
  >
    <v-layout justify-space-between align-center>
      <v-layout align-center class="overflow-hidden font-weight-bold">
        <span>{{ text }}</span>
        <slot name="appendContent" />
      </v-layout>
      <v-icon
        v-if="appendIcon"
        right
        size="30">
        {{ appendIcon }}
      </v-icon>
    </v-layout>
  </v-btn>
</template>

<script>

export default {
  props: {
    text: String,
    innerIcon: String,
    appendIcon: String,
    disabled: Boolean
  }
}
</script>

<style lang="scss" scoped>
button {
  border-radius: 10px;
}
::v-deep {
  .v-btn__content {
    max-width: -webkit-fill-available;
    & span {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  .v-btn--block {
    min-width: auto;
  }
}
</style>
